import { useRef, useEffect } from 'react';
import gsap from 'gsap/all';
import { Image, Text, useUi } from '@weareconceptstudio/core';

//* Styles
import ProductItemStyle from './style';

//* Helpers
import { config } from '@/helpers';

//* Components
import Button from '@/components/Button';
import CustomLink from '@/components/CustomLink';

const ProductItem = ({ featured_title, slug, featured_image, volume, className, isHome }) => {
	const infoWrapperRef = useRef(null);
	const buttonRef = useRef();
	const wrapperAllRef = useRef();
	const wrapSvg = useRef();
	const styleRef = useRef();

	const { winWidth, isMobile } = useUi();

	useEffect(() => {
		if (buttonRef.current && wrapperAllRef.current) {
			wrapperAllRef.current.style.setProperty('--buttonHeight', buttonRef.current.offsetHeight + 'px');
		}
	}, [winWidth]);

	// useEffect(() => {
	// 	if (isHome && wrapSvg.current) {
	// 		const allPath = wrapSvg.current.querySelectorAll('path');
	// 		const pathLine = [...allPath].slice(0, 4);
	// 		const pathTerev = [...allPath].slice(4);

	// 		allPath.forEach((item, index) => {
	// 			if (index === 4 || index === 5) {
	// 				item.style.clipPath = 'inset(0 0 100% 100%)';
	// 			} else {
	// 				const length = item.getTotalLength();
	// 				item.style.strokeDasharray = length;
	// 				item.style.strokeDashoffset = length;
	// 			}
	// 		});

	// 		const SPEED = 1200;
	// 		const MIN_DURATION = 0.2;

	// 		const getDurations = (paths, speed) =>
	// 			paths.map((item) => {
	// 				const length = item.getTotalLength();
	// 				return Math.max(Math.abs(length) / speed, MIN_DURATION);
	// 			});

	// 		const handleEnter = () => {
	// 			const durations = getDurations(pathLine, SPEED);

	// 			let delay = 0;
	// 			pathLine.forEach((item, index) => {
	// 				gsap.killTweensOf(item);

	// 				const length = item.getTotalLength();
	// 				const duration = durations[index];
	// 				const currentOffset = parseFloat(item.style.strokeDashoffset);

	// 				gsap.to(item, { delay, duration: 0 }).then(() => {
	// 					gsap.fromTo(
	// 						item,
	// 						{ strokeDashoffset: isNaN(currentOffset) ? length : currentOffset },
	// 						{
	// 							strokeDashoffset: 0,
	// 							duration,
	// 							ease: 'linear',
	// 							// delay,
	// 							overwrite: 'auto',
	// 						}
	// 					);
	// 				});

	// 				delay += duration;
	// 			});
	// 			const allLineTime = durations.slice(0, 2).reduce((acc, d) => acc + d, 0);

	// 			pathTerev.forEach((item) => {
	// 				gsap.killTweensOf(item);
	// 				gsap.to(item, {
	// 					clipPath: 'inset(0 0 0% 0%)',
	// 					duration: 0.1,
	// 					ease: 'power2.out',
	// 					delay: allLineTime,
	// 					overwrite: 'auto',
	// 				});
	// 			});
	// 		};

	// 		const handleLeave = () => {
	// 			const speedLeave = 1200;
	// 			const durations = getDurations(pathLine, speedLeave);

	// 			let delay = 0;
	// 			[...pathLine].reverse().forEach((item, idx, arr) => {
	// 				gsap.killTweensOf(item);

	// 				const realIndex = arr.length - 1 - idx;
	// 				const length = item.getTotalLength();
	// 				const duration = durations[realIndex];
	// 				const currentOffset = parseFloat(item.style.strokeDashoffset);

	// 				const lengthCurrent = idx == 0 || idx == 3 ? length + 0.01 : length;

	// 				gsap.to(item, { delay, duration: 0 }).then(() => {
	// 					gsap.fromTo(
	// 						item,
	// 						{ strokeDashoffset: isNaN(currentOffset) ? 0 : currentOffset },
	// 						{
	// 							strokeDashoffset: lengthCurrent,
	// 							duration,
	// 							ease: 'linear',
	// 							// delay,
	// 							overwrite: 'auto',
	// 						}
	// 					);
	// 				});

	// 				delay += duration;
	// 			});

	// 			const allLineTime = durations.slice(0, 2).reduce((acc, d) => acc + d, 0) + MIN_DURATION / 2;

	// 			pathTerev.forEach((item) => {
	// 				gsap.killTweensOf(item);
	// 				gsap.to(item, {
	// 					clipPath: 'inset(0 0 100% 100%)',
	// 					duration: 0.1,
	// 					ease: 'power2.out',
	// 					delay: allLineTime,
	// 					overwrite: 'auto',
	// 				});
	// 			});
	// 		};

	// 		const node = styleRef.current;

	// 		if (!isMobile) {
	// 			node.addEventListener('mouseenter', handleEnter);
	// 			node.addEventListener('mouseleave', handleLeave);
	// 		}

	// 		return () => {
	// 			node.removeEventListener('mouseenter', handleEnter);
	// 			node.removeEventListener('mouseleave', handleLeave);
	// 		};
	// 	}
	// }, [isHome, isMobile]);

	return (
		<ProductItemStyle
			ref={styleRef}
			className={`product-item-wrapper ${className || ''}`}>
			<div
				ref={wrapperAllRef}
				className='wrapper-all'>
				<CustomLink
					url={`${config.routes.products.path}${slug}`}
					className='product-item-link-wrapper'>
					<div>
						<div className={'material-item-wrapper'}>
							<div className='product-item-image-wrapper'>
								<Image
									className={'img-wrapper'}
									src={featured_image.src}
									alt={featured_image.alt}
								/>

								{/* {isHome ? (
									<div
										ref={wrapSvg}
										className='wrap svg'>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width={342}
											height={406}
											viewBox='0 0 342 406'
											fill='none'>
											<path
												d='M62.329 2C61.6049 3.125 61.4456 3.84474 60.8807 5.53938C60.3158 7.23403 60.3844 7.42318 59.8196 9.18764C59.1401 11.3101 59.115 13.347 58.9014 20.6609C58.7079 27.2831 58.3365 33.1786 58.9014 36.2146C59.2658 38.1732 60.5198 44.6504 61.4359 47.2675C62.3507 49.8808 63.4818 51.8521 64.1863 53.7562C65.2832 56.7209 67.1461 58.7576 69.2596 61.4424C70.9802 63.628 72.3675 66.6617 74.1257 69.1984C75.8905 71.7448 77.3013 73.7111 78.431 75.5496C79.7008 77.6159 81.5326 80.3374 83.1532 82.8106C84.9131 85.4964 86.8894 87.2514 88.5841 89.5109C90.2787 91.7704 92.5256 94.3007 94.3662 96.4926C97.0294 99.6639 99.8627 101.638 101.701 102.704C103.429 103.706 105.084 104.888 106.779 105.666C108.703 106.55 110.585 107.849 112.28 108.558C113.974 109.263 115.244 110.109 116.088 110.672C116.513 110.955 116.932 111.235 117.363 111.522'
												stroke='#39452A'
												style={{
													stroke: '#39452A',
													stroke: 'color(display-p3 0.2235 0.2706 0.1647)',
													strokeOpacity: 1,
												}}
												strokeWidth={4}
												strokeLinecap='round'
											/>

											<path
												d='M182.941 128.416C183.786 128.556 185.48 129.401 187.743 130.112C190.743 131.055 193.122 130.819 194.892 131.386C197.022 132.067 199.065 132.093 201.47 132.307C203.373 132.476 206.13 133.366 209.957 134.355C213.297 135.219 216.887 136.618 222.614 139.091C226.444 140.745 230.481 142.281 233.238 143.553C235.095 144.409 236.849 145.109 238.759 146.735C241.468 149.04 243.922 150.203 246.824 152.746C248.619 154.319 250.434 155.298 252.134 157.066C255.563 160.632 262.177 166.191 264.021 167.821C266.089 169.649 268.689 171.855 270.319 173.763C271.712 175.393 272.654 177.509 273.436 179.424C274.453 181.918 275.626 184.727 276.69 186.571C277.597 188.145 277.893 189.965 278.6 191.806C279.578 194.351 280.721 195.909 281.502 197.609C282.361 199.479 282.707 201.988 283.13 203.977C283.53 205.861 283.981 208.076 284.403 210.343C284.807 212.507 285.255 214.444 285.677 216.429C286.678 221.133 285.824 227.749 285.609 230.506'
												stroke='#39452A'
												style={{
													stroke: '#39452A',
													stroke: 'color(display-p3 0.2235 0.2706 0.1647)',
													strokeOpacity: 1,
												}}
												strokeWidth={4}
												strokeLinecap='round'
											/>
											<path
												d='M285.679 230.73C285.255 232.972 284.974 238.364 284.76 241.473C284.619 243.518 283.701 245.436 283.134 247.986C282.715 249.869 282.003 251.804 281.436 253.649C280.87 255.49 280.304 257.748 279.668 259.945C279.111 261.864 277.902 264.252 276.276 267.582C274.8 270.605 273.232 272.327 272.45 274.027C271.614 275.848 270.54 277.421 269.199 279.474C267.919 281.431 266.439 283.364 264.953 285.417C263.696 287.154 262.618 288.883 261.555 290.584C260.563 292.169 259.646 293.978 258.373 295.748C256.474 298.388 253.847 300.066 251.795 301.904C250.104 303.418 248.609 305.016 247.053 306.646C245.555 308.215 239.736 313.608 236.015 316.907C234.34 318.392 228.273 321.836 224.552 324.054C222.946 325.012 220.598 326.243 218.256 327.238C216.141 328.138 212.964 329.639 210.19 330.564C208.295 331.197 206.444 332.05 204.177 332.617C202.041 333.151 200.356 333.748 198.655 334.315C196.955 334.882 195.261 335.447 193.561 336.366C191.916 337.255 190.167 337.994 188.044 338.983C185.916 339.975 183.943 340.541 182.099 341.178C180.153 341.849 176.038 343.504 172.408 344.574C169.997 345.285 168.091 346.06 166.391 346.627C164.69 347.194 162.996 347.758 161.016 348.255C157.984 349.015 154.803 348.752 152.241 349.104C149.845 349.433 143.094 349.601 133.829 349.671C130.447 349.696 129.747 349.881 121.821 349.953C113.895 350.025 98.7641 350.025 90.7595 349.955C81.4684 349.874 79.5072 349.176 77.6626 348.754C75.9155 348.354 74.2684 347.622 72.5681 346.986C70.7572 346.307 69.1739 345.5 67.4036 344.581C65.219 343.446 62.8059 342.952 61.1056 342.386C59.4054 341.819 57.7115 341.254 55.5888 340.335C53.4274 339.399 51.3434 339.132 49.5731 338.495C47.4542 337.733 45.8244 337.009 44.0541 336.372C41.9352 335.61 40.0253 334.326 38.1807 333.048C36.4344 331.838 34.7865 330.08 33.0862 329.155C31.3567 328.214 30.1166 326.82 28.4163 325.831C26.65 324.803 25.0222 323.568 23.3219 322.435C21.6834 321.342 20.2079 320.316 18.5819 318.898C16.5019 317.084 14.8333 315.926 13.4854 314.511C12.2525 313.216 10.5879 312.386 9.31007 310.974C7.88436 309.399 6.62275 307.58 5.8416 305.88C5.03429 304.123 4.35573 302.486 3.78897 300.715C3.13908 298.685 2.93777 296.406 2.51536 294.417C2.11531 292.534 1.66417 288.917 2.3689 286.281C2.90458 284.277 2.93777 282.252 3.29014 280.338C3.66402 278.306 4.06704 276.309 4.6338 274.112C5.09862 272.31 5.76519 270.645 6.75436 268.945C7.7446 267.243 8.87279 265.551 10.5731 263.921C12.0776 262.478 13.9672 261.866 15.6675 260.947C17.7006 259.848 20.3353 258.894 22.458 258.257C24.6781 257.591 26.2788 256.772 28.4715 256.205C33.8739 254.808 41.9866 256.058 45.8711 256.273C48.5411 256.42 50.4774 257.332 52.1776 257.899C54.0479 258.522 56.8369 260.295 58.9702 261.365C60.6988 262.232 62.3644 262.851 64.0647 263.77C65.7099 264.659 67.4588 265.678 69.8638 267.869C71.5376 269.393 72.9778 270.773 74.3257 272.259C75.8137 273.604 76.8029 274.738 77.5798 275.373'
												stroke='#39452A'
												style={{
													stroke: '#39452A',
													stroke: 'color(display-p3 0.2235 0.2706 0.1647)',
													strokeOpacity: 1,
												}}
												strokeWidth={4}
												strokeLinecap='round'
											/>
											<path
												d='M226.318 372.714C228.789 375.02 231.866 377.662 239.771 383.176C244.046 386.159 251.554 390.265 255.634 392.567C261.748 396.017 265.679 397.489 268.456 398.585C271.827 399.915 276.891 400.988 280.989 402.083C284.409 402.998 287.982 402.886 290.977 403.107C293.835 403.317 293.548 403.839 303.298 403.916C307.571 403.949 312.169 403.472 315.302 403.107C321.891 402.339 323.689 402.3 325.887 401.205C327.783 400.26 331.492 397.575 333.244 396.042C335.364 394.187 337.999 388.241 338.804 385.329C340.486 379.239 340.048 373.49 339.457 369.37C339.313 368.784 339.024 368.207 338.804 367.621C338.583 367.035 338.438 366.458 338.29 365.426'
												stroke='#39452A'
												style={{
													stroke: '#39452A',
													stroke: 'color(display-p3 0.2235 0.2706 0.1647)',
													strokeOpacity: 1,
												}}
												strokeWidth={4}
												strokeLinecap='round'
											/>
											<path
												d='M274.525 264.485C273.001 268.966 272.503 273.494 272.06 277.975C271.617 282.456 271.819 287.084 272.456 291.596C273.094 296.108 273.491 300.768 275.194 305.055C276.897 309.342 279.191 312.203 281.858 316.025C285.24 312.443 288.654 309.877 291.523 305.861C294.393 301.845 297.091 297.419 298.094 292.511C298.88 288.697 298.149 284.766 297.464 280.929C296.78 277.091 296.438 273.029 294.766 269.548C293.079 266.044 290.023 263.299 287.791 260.113C285.559 256.926 283.335 254.399 280.94 251.344C279.696 251.058 281.453 252.236 280.808 253.329C278.615 257.035 275.925 260.415 274.533 264.485H274.525Z'
												fill='#39452A'
												style={{
													fill: '#39452A',
													fill: 'color(display-p3 0.2235 0.2706 0.1647)',
													fillOpacity: 1,
												}}
											/>
											<path
												d='M236.768 265.02C240.912 264.997 245.29 266.16 249.287 265.098C253.276 264.035 257.374 262.423 261.006 260.454C264.637 258.484 266.993 254.569 270.073 251.825C273.152 249.08 275.804 246.134 278.137 242.739C280.742 238.948 283.238 234.986 283.58 230.404L283.245 230.536C277.965 230.35 272.872 231.59 267.841 233.188C262.81 234.785 258.199 237.056 254 240.258C249.801 243.46 245.213 246.538 242.343 250.957C239.474 255.376 237.18 260.5 235.982 265.632'
												fill='#39452A'
												style={{
													fill: '#39452A',
													fill: 'color(display-p3 0.2235 0.2706 0.1647)',
													fillOpacity: 1,
												}}
											/>
										</svg>
									</div>
								) : null} */}
							</div>
							<div
								className={'material-item-info-wrapper'}
								ref={infoWrapperRef}>
								<div className='wrapper-text-outside'>
									<Text className='h6 font-larken-light align-center title'>{featured_title}</Text>
									<Text className='p1 font-fss-light description'>{volume}</Text>
								</div>
								<div
									ref={buttonRef}
									className='wrapper-button'>
									<div className='inner-wrapper-button'>
										<Button
											btnType={'yellow-type'}
											text={'moreDetail'}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</CustomLink>
			</div>
		</ProductItemStyle>
	);
};

export default ProductItem;
